import React from 'react';
import './Basket.css';
import BasketItem from './BasketItem';
import { Zoom } from 'react-awesome-reveal';
import { Link } from 'react-router-dom';
import LoadingPage from '../pages/LoadingPage';
import ClipLoader from "react-spinners/ClipLoader";

const Basket = ({ basket, emptyBasket, removeFromBasket, updateItemBasketQuantity, toggleDrawer, emptyingBasket }) => {
  const overrideSmaller = {
    display: "flex",
    borderWidth: '3px',
    height: '20px',
    width: '20px',
    position: 'absolute',
    left: '9px',
    top: '9px',
    zIndex: '2'
  };

  return (
    <div className='basket_container'>
      <div className='basket_header'>
        <div className='basket_exit' onClick={() => toggleDrawer()}></div>
        <div className='basket_info_container'>
          <h3 className='basket_size_separate' style={{ color: '#fff' }}>{basket?.lines?.edges?.length || 0}</h3>
          <img
            className='basket_icon_small'
            alt='Basket Icon'
            src={require('../../images/basket_icon.png')}
            loading="eager"
          />
          <h3 style={{ color: '#fff' }}>BASKET</h3>
        </div>
        {basket?.lines?.edges?.length > 0 &&
          <div className='empty_container'>
            <img
              className={emptyingBasket ? 'empty_basket_btn hide' : 'empty_basket_btn'}
              alt='Empty Icon'
              src={require('./../../images/icons8-bin-48.png')}
              loading="eager"
              onClick={() => {
                emptyBasket();
              }}
            />
            <ClipLoader
              color={'#C30D0D'}
              loading={emptyingBasket}
              cssOverride={overrideSmaller}
              size={'50px'}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        }
      </div>
      <div className='basket_content'>
        {!basket ? (
          <LoadingPage height="100%" />
        ) : (
          <>
            {basket.lines?.edges?.length > 0 ? (
              basket.lines.edges.map(({ node: item }) => (
                <BasketItem
                  key={item.id}
                  id={item.id}
                  title={item.merchandise.product.title}
                  servings={item.merchandise.selectedOptions[0]?.value}
                  quantity={item.quantity}
                  price={item.merchandise.price.amount * item.quantity}
                  image={item.merchandise.product.images.edges[0]?.node.url}
                  removeFromBasket={removeFromBasket}
                  updateItemBasketQuantity={updateItemBasketQuantity}
                />
              ))
            ) : (
              <Zoom triggerOnce={true} style={{ margin: '20px 5px 0 5px', textAlign: 'center' }}>
                <span style={{ lineHeight: '28px' }}>
                  You have no items in your basket. To add some, visit{' '}
                  <Link to="/market" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => {
                    window.scroll(0, 0);
                    toggleDrawer();
                  }}>
                    Chatters Market
                  </Link>.
                </span>
              </Zoom>
            )}
          </>
        )}
      </div>
      <div className='basket_footer'>
        <div className='subtotal_container'>
          <h3 style={{ display: 'flex' }}>SUBTOTAL</h3>
          <h3 style={{ display: 'flex' }}>
          {basket?.subtotalPrice ? `£${parseFloat(basket.subtotalPrice.amount).toFixed(2)}` : 
            <LoadingPage height="100%" />}          
          </h3>
        </div>
        <Link
          className='checkout_link'
          alt='Link Image'
          to='/checkout'
          onClick={() => {
            window.scroll(0, 0);
          }}
        >
          <button className='checkout_btn' onClick={() => toggleDrawer()}>CHECKOUT</button>
        </Link>
      </div>
    </div>
  );
}

export default Basket;
